// You'll need to set these in your environment variables
const PINDO_API_TOKEN = process.env.REACT_APP_PINDO_API_TOKEN;
const PINDO_SENDER_ID = process.env.REACT_APP_PINDO_SENDER_ID || "Bookinga";

const formatPhoneNumber = (phone) => {
  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("250")) return `+${digits}`;
  if (digits.startsWith("0")) return `+250${digits.slice(1)}`;
  return `+${digits}`;
};

export const sendSMS = async (phoneNumber, message) => {
  const formattedPhone = formatPhoneNumber(phoneNumber);
  console.log("got here", message, "to:", formattedPhone);

  try {
    if (!PINDO_API_TOKEN) {
      throw new Error("Pindo API token is not configured");
    }

    const response = await fetch("https://api.pindo.io/v1/sms/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PINDO_API_TOKEN}`,
      },
      body: JSON.stringify({
        to: formattedPhone,
        text: message,
        sender: PINDO_SENDER_ID,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error?.message || "Failed to send SMS");
    }

    return {
      success: true,
      messageId: data.id,
      status: data.status,
    };
  } catch (error) {
    console.error("Error sending SMS:", error);
    throw new Error(`SMS sending failed: ${error.message}`);
  }
};

// Send driver credentials via SMS
export const sendDriverCredentials = async (driverData, credentials) => {
  const { name, phone } = driverData;
  const {  password } = credentials;

  const message = `Welcome to Be Fleet, ${name}! 

Ubu wakwinjira muri system ukoresheje numero yawe na 
Password: ${password}
link https://www.befleet.rw
murakoze.`;

  return await sendSMS(phone, message);
};

export const sendRejectedReportSMS = async (driverData, reviewNote = "") => {
  const { name, phone } = driverData;
  const trimmedReviewNote = reviewNote?.trim();

  const message = `Muraho ${name || "Driver"}, raport mwatanze ntabwo yemejwe. Jya muri system uyikosore wongere uyitange.${trimmedReviewNote ? ` Impamvu: ${trimmedReviewNote}` : ""}`;

  return await sendSMS(phone, message);
};
